import React, { useRef, useState } from 'react';
import ModulesDropdown from '../dropdown/Modules.dropdown';
import ModulesTreeView from '../treeView/Modules.treeview';
import NotificationMessage from '../../errorBoundary/ErrorBoundary';
import { SidebarComponent } from '@syncfusion/ej2-react-navigations';
import PropTypes from 'prop-types';
import PolicyButtonBar from '../../../pages/module/workspaces/components/policy/Policy.buttonBar';
import PolicyDialog from '../../../pages/module/workspaces/components/policy/Policy.dialog';
import CookieConsentComponent from '../../../pages/login/components/cookies/Cookie.consent';
import './styles.css';

const ModuleNavigation = ({ workspace, isMenuOpen, handleLeftSidebar }) => {
  const sidebarRef = useRef(null);
  const [dialogVisiblePolicy, setDialogVisiblePolicy] = useState(false);
  const [dialogContentPolicy, setDialogContentPolicy] = useState(null);
  const [dialogVisibleCookies, setDialogVisibleCookies] = useState(false);
  const [dialogContentCookies, setDialogContentCookies] = useState(null);

  return (
    <div className={`h-full transition-all duration-300 ${isMenuOpen ? 'w-[300px]' : 'w-[30px]'}`}>
      <SidebarComponent
        ref={sidebarRef}
        width={isMenuOpen ? '300' : '30'}
        enableGestures={false}
      >
        {!isMenuOpen && <div
          className={'ml-3 rounded-full cursor-pointer'}
          onClick={handleLeftSidebar}
        >
          <span
            className={`e-icons ${
              isMenuOpen ? 'e-chevron-left-double' : 'e-chevron-right-double'
            } text-gray-400 text-xs hover:text-gray-50`}
          />
        </div>}
        <div className={`navigation-content ${isMenuOpen ? '' : 'hidden'}`}>
          <NotificationMessage>
            <ModulesDropdown workspace={workspace} />
          </NotificationMessage>

          <NotificationMessage>
            <ModulesTreeView workspace={workspace} />
          </NotificationMessage>

          <PolicyButtonBar
            setPolicyDialogOpen={setDialogVisiblePolicy}
            setPolicyContent={setDialogContentPolicy}
            setCookiesDialogOpen={setDialogVisibleCookies}
            setCookiesContent={setDialogContentCookies}
          />

          <PolicyDialog
            policyDialogOpen={dialogVisiblePolicy}
            setPolicyDialogOpen={setDialogVisiblePolicy}
            policyContent={dialogContentPolicy}
          />

          <CookieConsentComponent
            cookiesDialogOpen={dialogVisibleCookies}
            setCookiesDialogOpen={setDialogVisibleCookies}
            cookiesContent={dialogContentCookies}
            type="system"
          />
        </div>
      </SidebarComponent>
    </div>
  );
};

ModuleNavigation.propTypes = {
  isMenuOpen: PropTypes.bool,
  handleLeftSidebar: PropTypes.func,
  workspace: PropTypes.object,
};

export default ModuleNavigation;
